import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, EyeOffIcon } from 'lucide-react';
import { useAcademyHub } from '../../../context/AcademyHub';
import { Button } from '../../ui/Button';
import { timeAgo } from '../../../utils/academyFormat';
export function AdminModeration() {
  const {
    hub,
    moderate
  } = useAcademyHub();
  const pending = hub.flags.filter(f => f.status === 'pending');
  const reviewed = hub.flags.filter(f => f.status !== 'pending');
  const findPost = (type: 'thread' | 'reply', id: string) => {
    if (type === 'thread') {
      const t = hub.threads.find(x => x.id === id);
      return t ? {
        author: t.author.name,
        text: `${t.title}. ${t.body}`,
        link: `/academy/community/${t.channel}/${t.id}`
      } : null;
    }
    const r = hub.replies.find(x => x.id === id);
    const t = r && hub.threads.find(x => x.id === r.threadId);
    return r && t ? {
      author: r.author.name,
      text: r.body,
      link: `/academy/community/${t.channel}/${t.id}`
    } : null;
  };
  return <div data-id="element-228" data-mp="149ishqu2mv20">
      <h2 className="text-[16px] font-medium text-ink" data-id="element-229" data-mp="149sj9gmxx68r">Queue</h2>
      {pending.length ? <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-230" data-mp="18a2sr39xyesd">
          {pending.map(f => {
        const post = findPost(f.postType, f.postId);
        return <li key={f.id} className="grid gap-4 py-5 lg:grid-cols-[1fr_auto] lg:items-start" data-id="element-231" data-mp="1i04dbl335f2j">
                <div className="min-w-0" data-id="element-232" data-mp="laenqu9kbng5">
                  <p className="text-small text-muted" data-id="element-233" data-mp="lbg7dn4n9i9h">
                    <span className="text-royal" data-id="element-234" data-mp="pbglf6ntzrg0">{f.reason}</span> · {f.postType} by {post?.author ?? 'unknown'} · reported {timeAgo(f.createdAt)}
                  </p>
                  <p className="mt-2 line-clamp-3 text-[15px] text-body" data-id="element-235" data-mp="ucwb5c0yem4q">{post?.text ?? 'This post no longer exists.'}</p>
                  {post && <Link to={post.link} className="mt-2 inline-block text-small text-royal underline underline-offset-4 hover:text-ink" data-id="element-236" data-mp="25qrrgo3lh0xj">
                      View in context
                    </Link>}
                </div>
                <div className="flex gap-2" data-id="element-237" data-mp="1l30jl7j5ash9">
                  <Button type="button" variant="secondary" size="sm" onClick={() => moderate(f.id, 'approve')} data-id="element-238" data-mp="1g2ckrzood7ch">
                    <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-239" data-mp="1uy2944hc1wkd" />
                    Keep
                  </Button>
                  <Button type="button" size="sm" onClick={() => moderate(f.id, 'hide')} data-id="element-240" data-mp="1q0jz0arkxbas">
                    <EyeOffIcon className="h-4 w-4" aria-hidden="true" data-id="element-241" data-mp="12axxvhrncm05" />
                    Hide
                  </Button>
                </div>
              </li>;
      })}
        </ul> : <p className="mt-4 rounded-md border border-dashed border-line px-5 py-8 text-center text-[14px] text-muted" data-id="element-242" data-mp="1c1k6gs0y4c9c">
          Nothing waiting. Reports from the community appear here.
        </p>}

      {reviewed.length > 0 && <>
          <h2 className="mt-10 text-[16px] font-medium text-ink" data-id="element-243" data-mp="eldfp13bhsrx">Reviewed</h2>
          <ul className="mt-3 space-y-2 text-small text-body" data-id="element-244" data-mp="2q876ejr6c6be">
            {reviewed.map(f => <li key={f.id} data-id="element-245" data-mp="2uyxa7sjyc13z">
                {f.reason}, {f.postType}: <span className={f.status === 'hidden' ? 'text-royal' : 'text-ink'} data-id="element-246" data-mp="2v0i2tcmph9z7">{f.status === 'hidden' ? 'hidden' : 'kept'}</span>
              </li>)}
          </ul>
        </>}
    </div>;
}